import React, { useEffect } from 'react';
export function Privacidad() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="legal-page" data-id="element-579">
      <div className="legal-hero" data-id="element-580">
        <p className="legal-overline" data-id="element-581">Transparencia total</p>
        <h1 className="legal-title" data-id="element-582">Política de privacidad</h1>
        <p className="legal-subtitle" data-id="element-583">
          SAVIA · Última actualización: junio 2025
        </p>
      </div>
      <div className="legal-body" data-id="element-584">
        <div className="legal-section" data-id="element-585">
          <h2 data-id="element-586">1. Quién somos</h2>
          <p data-id="element-587">
            SAVIA es una marca de velas artesanales con sede en Bogotá,
            Colombia. Operamos bajo el sitio web saviacolombia.com y el canal de
            ventas @savia.ritualco en Instagram.
          </p>
          <p data-id="element-588">
            Para cualquier consulta relacionada con privacidad y datos, puedes
            escribirnos a través de WhatsApp al +57 321 339 6782.
          </p>
        </div>
        <div className="legal-section" data-id="element-589">
          <h2 data-id="element-590">2. Qué datos recopilamos</h2>
          <p data-id="element-591">Al realizar una compra o contactarnos, podemos recopilar:</p>
          <ul data-id="element-592">
            <li data-id="element-593">Nombre completo</li>
            <li data-id="element-594">Dirección de envío</li>
            <li data-id="element-595">Correo electrónico</li>
            <li data-id="element-596">Número de teléfono / WhatsApp</li>
            <li data-id="element-597">
              Información de pago (procesada por MercadoPago — no la
              almacenamos)
            </li>
            <li data-id="element-598">Historial de pedidos</li>
          </ul>
        </div>
        <div className="legal-section" data-id="element-599">
          <h2 data-id="element-600">3. Para qué usamos tus datos</h2>
          <ul data-id="element-601">
            <li data-id="element-602">Procesar y despachar tu pedido</li>
            <li data-id="element-603">Enviarte actualizaciones sobre tu envío</li>
            <li data-id="element-604">Responder tus consultas</li>
            <li data-id="element-605">Mejorar nuestros productos y servicio</li>
            <li data-id="element-606">Enviarte comunicaciones de SAVIA (solo si lo autorizas)</li>
          </ul>
          <p data-id="element-607">
            <strong data-id="element-608">No vendemos ni compartimos</strong> tus datos personales con
            terceros, excepto con los operadores logísticos necesarios para
            realizar el envío.
          </p>
        </div>
        <div className="legal-section" data-id="element-609">
          <h2 data-id="element-610">4. Cookies y datos de navegación</h2>
          <p data-id="element-611">
            Nuestro sitio puede usar cookies técnicas necesarias para el
            funcionamiento de la tienda y cookies analíticas para entender cómo
            los usuarios interactúan con la página.
          </p>
          <p data-id="element-612">
            Puedes desactivar las cookies desde la configuración de tu navegador
            en cualquier momento.
          </p>
        </div>
        <div className="legal-section" data-id="element-613">
          <h2 data-id="element-614">5. Almacenamiento y seguridad</h2>
          <p data-id="element-615">
            Tus datos se almacenan en la plataforma Shopify, que cumple con los
            estándares internacionales de seguridad PCI DSS. Los pagos son
            procesados por MercadoPago bajo sus propias políticas de seguridad y
            privacidad.
          </p>
        </div>
        <div className="legal-section" data-id="element-616">
          <h2 data-id="element-617">6. Tus derechos</h2>
          <p data-id="element-618">
            De acuerdo con la Ley 1581 de 2012 (Protección de Datos Personales —
            Colombia), tienes derecho a:
          </p>
          <ul data-id="element-619">
            <li data-id="element-620">Conocer qué datos tenemos sobre ti</li>
            <li data-id="element-621">Actualizar o corregir tu información</li>
            <li data-id="element-622">Solicitar la eliminación de tus datos</li>
            <li data-id="element-623">Revocar la autorización para el uso de tus datos</li>
          </ul>
          <p data-id="element-624">
            Para ejercer estos derechos escríbenos por WhatsApp al +57 321 339
            6782.
          </p>
        </div>
        <div className="legal-section" data-id="element-625">
          <h2 data-id="element-626">7. Menores de edad</h2>
          <p data-id="element-627">
            SAVIA no recopila datos de menores de 18 años. Si eres menor de
            edad, necesitas autorización de un adulto responsable para realizar
            compras.
          </p>
        </div>
        <div className="legal-section" data-id="element-628">
          <h2 data-id="element-629">8. Cambios a esta política</h2>
          <p data-id="element-630">
            Podemos actualizar esta política ocasionalmente. Cualquier cambio
            significativo será notificado a través de nuestros canales
            oficiales. El uso continuado del sitio implica aceptación de la
            política vigente.
          </p>
        </div>
      </div>
    </div>;
}